import {
  CourseDetailSchema,
  CourseEnquiryProfileSchema,
  CourseEnquiryResponseSchema,
} from "@artha/api-contracts";
import type { CourseDetailProps } from "../learning.types";
import type { CourseEnquiryDto } from "@artha/api-contracts";
import { LEARNING_PATH } from "../learning.constants";
import { learningRequest } from "./courseClient";

/** Keep creator and optional source job context in an Artha-owned detail route. */
export function courseDetailPath(
  creator: string,
  courseId: string,
  jobId?: string,
): string {
  const path = `/@${encodeURIComponent(creator.replace(/^@/, ""))}/courses/${encodeURIComponent(courseId)}`;
  return jobId ? `${path}?${new URLSearchParams({ job: jobId })}` : path;
}

/** Source job IDs are accepted by the existing job-detail route; direct course links fall back to the creator. */
export function courseBackPath(creator: string, jobId?: string): string {
  const profile = `/@${encodeURIComponent(creator.replace(/^@/, ""))}`;
  return jobId?.trim()
    ? `${profile}/jobs/${encodeURIComponent(jobId)}`
    : profile;
}
/** Validate detail responses before rendering or using their signed action intent. */
export async function fetchCourseDetail(
  props: CourseDetailProps,
  signal?: AbortSignal,
) {
  return CourseDetailSchema.parse(
    await learningRequest(
      LEARNING_PATH.detail,
      {
        entity_id: props.courseId,
        creator_handle: props.creatorHandle,
        job_id: props.jobId || "",
      },
      signal,
    ),
  );
}
/** Accept only a validated persisted receipt from the enquiry endpoint. */
export async function submitCourseEnquiry(input: CourseEnquiryDto) {
  const result = await learningRequest<{ data: unknown }>(
    LEARNING_PATH.enquiries,
    input,
  );
  return CourseEnquiryResponseSchema.parse(result.data);
}

/** Read only this browser's saved enquiry profile; the server may create a guest session. */
export async function fetchEnquiryProfile(signal?: AbortSignal) {
  const response = await learningRequest<{ data: unknown }>(
    LEARNING_PATH.enquirySession,
    {},
    signal,
  );
  return CourseEnquiryProfileSchema.parse(response.data);
}
